import React, { useEffect } from 'react';
import { Routes, Route } from "react-router-dom";



import Navbar from './component/Navbar';
import Footer from './component/Footer';
import Home from './component/Home';
import Forms from './component/pages/forms';
import ContactPage from './component/pages/Contact';
import AboutPage from './component/pages/AboutPage';
import GR from './component/pages/GR';

import TnC from './component/TnC';
import TermsAndConditions from "./component/tncPages/TermsAndConditions";
import PrivacyPolicy from "./component/tncPages/PrivacyPolicy";
import RefundPolicy from "./component/tncPages/RefundPolicy";
import ShippingPolicy from "./component/tncPages/ShippingPolicy";
import PricingPlans from "./component/pages/pricing";
import TncFooter from './component/tncPages/tncLinks';

import LoadingPage from './component/Loader';

import Arrears from './component/pages/Arrears';
import SeniorCollege from './component/pages/SeniorCollege';
import PSHSchool from './component/pages/PSHSchool';
import Pension from './component/pages/Pension';


import SrPlacementForm from './component/senior/placement/srPlacement';
import SrPlacementResult from './component/senior/placement/result/SeniorCollegePlacementResult';
import SrScaleFixation from './component/senior/FixationScale/srScaleFixation';
import SrScaleFixationResult from './component/senior/FixationScale/srScaleFixationResult';

import HsNewAppointment from './component/High School/New_Appointement/newAppointmentHS';
import HsNewAppointmentResult from './component/High School/New_Appointement/newAppointmentHSResult';

import ArrearSeventh from './component/Arrear/arrearsCalculatorseventToseventh/ArrearsSeventh';
import ArrearsSeventhResult from './component/Arrear/arrearsCalculatorseventToseventh/Result/ArrearsSeventhResult';
import DaArrearsForm from './component/Arrear/DA_Arrears/daArrears';
import DaArrearsResult from './component/Arrear/DA_Arrears/daArrearsResult';

import PensionSr from './component/Pension/forms/pensionSr';
import PensionResult from './component/Pension/Results/pensionResult';
import PensionHighSchool from './component/Pension/forms/pensionHightSchool';
import PensionHighSchoolResult from './component/Pension/Results/pensionHighSchoolResult';

import AdminPanel from './component/pages/admin/paymentAdmin';
import AdminLogin from './component/pages/admin/AdminLogin';
import AdminDashboard from './component/pages/admin/AdminDashboard';
import { AuthProvider } from './component/pages/admin/context/AuthContext';
import ProtectedRoute from './component/pages/admin/components/ProtectedRoute';

import './App.css';
import './style/scrollbar.css';
const App = () => {
  useEffect(() => {
    const handleWheel = (e) => {
      if (
        document.activeElement &&
        document.activeElement.type === "number"
      ) {
        document.activeElement.blur(); // remove focus to prevent scroll changes
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);
  return (
    <div>
      <AuthProvider>
        <Navbar />
        <Routes>
        <Route path="/LoadingPage" element={<LoadingPage/>} />

          {/* Define all your routes inside Routes */}
          <Route path="/" element={<Home/>} />
          <Route path="/Forms" element={<Forms/>} />
          <Route path="/ContactPage" element={<ContactPage/>} />
          <Route path="/AboutPage" element={<AboutPage/>} />
          <Route path="/GR" element={<GR/>} />
          <Route path="/tnc" element={<TnC/>} />
          <Route path="/pricing-plans" element={<PricingPlans />} />

          <Route path="/Arrears" element={<Arrears/>} />
          <Route path="/SeniorCollege" element={<SeniorCollege/>} />
          <Route path="/PriSecHSchool" element={<PSHSchool/>} />
          <Route path="/pension" element={<Pension/>} />

          {/*Senior College Forms */}
          <Route path="/srPlacementForm" element={<SrPlacementForm/>} />
          <Route path="/srPlacementForm/srPlacement-result/:uniqueFormId" element={<SrPlacementResult/>} />
          <Route path="/srScaleFixation" element={<SrScaleFixation/>} />
          <Route path="/srScaleFixation/srScaleFixation-result/:uniqueFormId" element={<SrScaleFixationResult/>} />
          
          {/*High School Forms */}
          <Route path="/hsNewAppointment" element={<HsNewAppointment/>} />
          <Route path="/hsNewAppointment/hsNewAppointment-result/:uniqueFormId" element={<HsNewAppointmentResult/>} />
          
          {/* Arrears route */}
          <Route path="/arrearesSeventh" element={<ArrearSeventh />} />
          <Route path="/arrearesSeventh/arrears_seventh_result/:uniqueFormId" element={<ArrearsSeventhResult/>} />
          <Route path="/daArrearsForm" element={<DaArrearsForm />} />
          <Route path="/daArrearsForm/daArrears-result/:uniqueFormId" element={<DaArrearsResult />}/>

          {/*Pension Forms*/}
          <Route path="/pensionSr" element={<PensionSr/>} />
          <Route path="/pensionsr/pensionCase-result/:uniqueFormId" element={<PensionResult />}/>
          <Route path="/pensionHighSchool" element={<PensionHighSchool/>} />
          <Route path="/pensionHighSchool/pensionCase-result/:uniqueFormId" element={<PensionHighSchoolResult />}/>


          {/*admin routes */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin-dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/adminpay" element={
            <ProtectedRoute>
              <AdminPanel/>
            </ProtectedRoute>
          } />

          
          {/* TnC Pages */}
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/tncFooter" element={<TncFooter />} />

        </Routes>
        <Footer />
      </AuthProvider>
    </div>
  );
};

export default App;
